import React from "react";
import Header from "../components/Header";

const MoviePage = () => {
  return (
    <div>
      <Header />
      <div className="page_content">
        <h1>Movies</h1>
      </div>
    </div>
  );
};

export default MoviePage;
